import React from 'react';
import './Preloader.css';
import logo from './justseologo.png'; // Make sure it's in the same folder or adjust the path

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="preloader-icon">
        <div className="globe">
          <img src={logo} alt="Just SEO Logo" className="preloader-logo" />
        </div>
      </div>
      <div className="preloader-text">Your Rankings, Our Mission...</div>
    </div>
  );
};

export default Preloader;
